export default __webpack_public_path__ + "static/media/return-arrow-medium.c596ac6f.svg";